var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8 14h2V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11h2v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm3-9h2a2 2 0 0 1 2 2v8H1V3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm0 1v8h3V7a1 1 0 0 0-1-1h-2zm-6 8h2v-2H5v2zM4 4h1v2H4V4zm3 0h1v2H7V4zM4 7h1v2H4V7zm3 0h1v2H7V7z" })
  );
});